import React from "react";

import { SubBody } from "Cobalt/BodyText";
import { SIFinalFormFieldNoCol, SIFormInput } from "Common/forms";
import { Div } from "Common/HTML";

import makeBem from "Utils/makeBem";

const bem = makeBem("QuoteEmployeePriceBreakdown");

const contributionTypeToggle = (contributionType, onToggle) => {
  const percentageClass = ["contributionToggleButton", "left"];
  const fixedClass = ["contributionToggleButton", "right"];
  if (contributionType == "fixed") {
    fixedClass.push("selected");
  } else {
    percentageClass.push("selected");
  }
  return (
    <div className={bem("contributionToggleContainer")}>
      <button className={percentageClass.join(" ")} onClick={() => onToggle("percentage")}>
        %
      </button>
      <button className={fixedClass.join(" ")} onClick={() => onToggle("fixed")}>
        $
      </button>
    </div>
  );
};

export const QuoteEmployeeMockContributions = ({ contributionType, onToggle }) => {
  const placeholderText = `Enter ${contributionType == "fixed" ? "amount" : "percentage"}`;
  return (
    <>
      <SubBody mb={3}>Adjust the portion of your employee's health coverage you would like to cover</SubBody>
      <Div mb={4}>
        <SIFinalFormFieldNoCol
          name="employee_contribution"
          label="For Employees"
          componentProps={{
            placeholder: placeholderText,
            type: "number",
          }}
          component={SIFormInput}
        />

        {contributionTypeToggle(contributionType, onToggle)}
      </Div>
      <Div>
        <SIFinalFormFieldNoCol
          name="dependent_contribution"
          label="For Dependents"
          componentProps={{
            placeholder: placeholderText,
            type: "number",
          }}
          component={SIFormInput}
        />

        {contributionTypeToggle(contributionType, onToggle)}
      </Div>
    </>
  );
};

export default QuoteEmployeeMockContributions;
